const fn = {
    init: () => {
        if ($('.side-menu__block-inner').length) {
            $('.side-menu__block-inner').mCustomScrollbar({
                axis: 'y',
                theme: 'dark',
            });
        }

        if ($('.side-menu__toggler').length) {
            $('.side-menu__toggler').on('click', function (e) {
                $('.side-menu__block').addClass('active');
                e.preventDefault();
            });
        }

        if ($('.side-menu__block-overlay').length) {
            $('.side-menu__block-overlay').on('click', function (e) {
                $('.side-menu__block').removeClass('active');
                e.preventDefault();
            });
        }
    }
}

export default {
    can: () => true,
    run: fn.init,
};
